export class Vertical {
    [key: string]: string | number | undefined
    public id: number | undefined;
    public parentId: number | undefined;
    public name: string | undefined;
    public defaultFallow: number | undefined;
}